import { Dispatch, FC, MouseEvent, SetStateAction, useState } from 'react'
import ReactCodeInput from '@acusti/react-code-input'
import Button from 'react-bootstrap/Button'

import { isIOS } from 'share/utils/isiOs'
import { NextData } from 'components/features/accountcreation/NewAccountMain'
import {
  CodeVerificationContainer,
  CodeVerificationSend,
  CodeVerificationSubmit,
  CodeVerifyWithinInfo,
  iOSCodeInputStyle
} from 'components/atoms/InputFields/CodeVerification'

const style = !isIOS ? {} : iOSCodeInputStyle

interface NewAccountVerifyYourEmailAddressFormProps {
  completeEmailVerificationHelper(input: string): void
  enteredCode: string
  enteredCodeComplete: boolean
  nextStep(data: NextData): void
  resendVerificationCode: () => void
  setEnteredCode: Dispatch<SetStateAction<string>>
  setEnteredCodeComplete: Dispatch<SetStateAction<boolean>>
}

const NewAccountVerifyYourEmailAddressForm: FC<NewAccountVerifyYourEmailAddressFormProps> =
  ({
    completeEmailVerificationHelper,
    enteredCode,
    enteredCodeComplete,
    resendVerificationCode,
    setEnteredCode,
    setEnteredCodeComplete
  }) => {
    const [submitting, setSubmitting] = useState(false)
    const onSubmit = async (e: MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      setSubmitting(true)
      await completeEmailVerificationHelper(enteredCode)
      setSubmitting(false)
    }

    const handleCodeChange = (val: string) => {
      if (val?.length === 6) {
        setEnteredCode(val)
        setEnteredCodeComplete(true)
        return
      }

      setEnteredCodeComplete(false)
    }

    return (
      <CodeVerificationContainer data-testid='create-account-account-verify-email-verification-code-container'>
        <p>Please enter the verification code below.</p>
        <ReactCodeInput
          autoFocus
          className='ui-code-verification-inputs'
          fields={6}
          inputMode='numeric'
          inputStyle={style}
          name='verifyEmail'
          type='number'
          value={enteredCode}
          onChange={handleCodeChange}
        />
        <CodeVerifyWithinInfo>
          Please verify within 5 minutes.
        </CodeVerifyWithinInfo>
        <CodeVerificationSend data-testid='create-account-account-verify-email-verification-code-send'>
          Didn't get a code?{' '}
          <span
            role='button'
            onClick={resendVerificationCode}
            data-testid='create-account-account-verify-email-resend-code-button'
          >
            Send it again
          </span>
        </CodeVerificationSend>
        <CodeVerificationSubmit>
          <Button
            className='ui-button-with-spinner'
            disabled={!enteredCodeComplete || submitting}
            type='submit'
            onClick={onSubmit}
            data-testid='create-account-account-verify-email-next-button'
          >
            Next
          </Button>
        </CodeVerificationSubmit>
      </CodeVerificationContainer>
    )
  }

export default NewAccountVerifyYourEmailAddressForm
